import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { PageTransition } from '../../components/Transitions/PageTransition';
import { isGuideStale, listGuides } from '../../content/guides';
import { useLanguage } from '../../contexts/LanguageContext';
import { formatDate } from '../../lib/format';

export function GuidesPage() {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const guides = listGuides(language);

  return (
    <PageTransition>
      <div className="mx-auto max-w-3xl px-4 py-10 space-y-8">
        <header className="space-y-2">
          <h1 className="text-2xl font-bold text-text-primary [text-wrap:balance]">{t('guides.title')}</h1>
          <p className="max-w-[65ch] text-text-secondary [text-wrap:pretty]">{t('guides.subtitle')}</p>
        </header>

        <ul className="divide-y divide-border overflow-hidden rounded-xl border border-border bg-surface">
          {guides.map((guide) => (
            <li key={guide.slug}>
              <Link
                to={`/guides/${guide.slug}`}
                className="block px-5 py-4 transition-colors hover:bg-elevated focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-primary"
              >
                <div className="flex flex-wrap items-center gap-2">
                  <h2 className="font-semibold text-text-primary">{guide.title}</h2>
                  {guide.status === 'draft' && (
                    <span className="rounded-full bg-status-warning/15 px-2 py-0.5 text-xs font-medium text-amber-800 dark:text-amber-300">
                      {t('guides.draft')}
                    </span>
                  )}
                </div>
                <p className="mt-1 max-w-[65ch] text-sm text-text-secondary">{guide.summary}</p>
                <p className="mt-2 text-xs text-text-muted">
                  {t('guides.reviewedOn', { date: formatDate(guide.reviewed, language, { year: 'numeric', month: 'long', day: 'numeric' }) })}
                  {isGuideStale(guide) && <span className="ms-2 text-amber-800 dark:text-amber-300">{t('guides.mayBeOutdated')}</span>}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </PageTransition>
  );
}
